var map = {
	"./apiParamsInitialization.js": 8,
	"./gameParameters.js": 9,
	"./httpResponse.js": 10,
	"./messageHelper.js": 11,
	"./notificationType.js": 12,
	"./notificationsName.js": 13,
	"./resources.js": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;